<template>
  <div class="layout2" style="background: #f2f5f7">
    <div class="peaceTab1">
      <nyhead
        :marks="row.value"
        :name="row.name"
        @handClickFs="handClickFs"
      ></nyhead>
      <div class="intes-bt-box" v-show="row.son.length !== 0">
        <zklist :list="row.son"></zklist>
        <div class="tswz">
          该分析为功能评估，结果不作为临床诊断标准，如需诊断是否患有疾病，请到专业医疗机构进行诊断检查。
        </div>
      </div>

      <div v-show="row.son.length == 0" style="text-align: center">
        暂无数据
      </div>
    </div>
    <van-dialog
      class="peaceComDialog"
      v-model="showSuccess"
      title="健康分数说明"
      messageAlign="left"
      closeOnClickOverlay
      confirmButtonColor="#A7DDFF"
      confirmButtonText="关闭"
      theme="round-button"
      width="320"
      className="peaceH5dialogText"
    >
      <markbox :item="fsSta"></markbox>
    </van-dialog>
    <ball :text="'返回'"></ball>
  </div>
</template>
<script>
import zklist from "./components/noZklistrtst.vue"
import nyhead from "./components/nyhead.vue"
import markbox from "./components/markBox.vue"
import ball from "./components/ball.vue"
export default {
  components: {
    zklist, nyhead, markbox, ball
  },
  data () {
    return {
      activeNames: [],
      row: {},
      showSuccess: false,
      fsSta: {
        status: '优',
        level: 4,
        value: 85
      },
    }
  },
  created () {
    document.title = '身体状况'
    // document.documentElement.scrollTop = 1000
    this.row = JSON.parse(decodeURIComponent(this.$route.query.row))
    console.log(this.row)
  },
  methods: {
    handClickFs () {
      this.showSuccess = true
    },
  }
}
</script>
<style lang="scss" >
.mytab1 {
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  overflow: hidden;
  margin: 0 30px;
}
.peaceTab1 {
  padding-top: 30px;

  .van-tabs__nav--card {
    height: 100px !important;
    .van-tab {
      width: 160px !important;
      height: 60px !important;
      background: #e1f1ff;
      box-shadow: 0px 10px 13px 0px rgba(47, 153, 231, 0.3);
      border-radius: 30px;
      margin-right: 20px;
      padding: 0 !important;

      flex: 0 0 24% !important;
    }
  }
  .van-cell__value {
    padding-top: 20px;
    font-size: 26px;
    flex: 0.5;
    padding-right: 20px;
  }
  .van-cell__right-icon {
    margin-top: 20px !important;
  }
  .van-tab__text {
    font-size: 28px;
  }
  .van-tab--active {
    width: 160px !important;
    height: 60px !important;
    background: #008def !important;

    box-shadow: 0px 10px 13px 0px rgba(47, 153, 231, 0.3) !important;
    border-radius: 30px !important;
  }
  .van-tabs__wrap {
    height: 100px !important;
  }
  .van-tabs__nav {
    background: none;
    border: none;
  }
  .van-tabs__content--animated {
    padding-top: 0;
  }
}

.tswz {
  font-size: 20px;
  color: #666;
  margin: 30px 0;
  line-height: 30px;
  padding: 0 30px;
}
</style>